/**
 * The mini difficulty gauge from the pre-023 /problems phone layout — a green-to-red arc
 * with a needle at `level`/10. Shown in the compact masthead row once the answer is in,
 * matching the old page's post-answer reveal.
 *
 * Feature-neutral: any table session that reveals a hand's difficulty draws it with this.
 */
export function DifficultyGauge({ level }: { level: number }) {
  const angle = Math.PI * (1 - level / 10);
  const nx = 8 + 5 * Math.cos(angle);
  const ny = 9 - 5 * Math.sin(angle);
  return (
    <span className="flex items-center gap-1 text-xs font-medium">
      <svg viewBox="0 0 16 10" className="h-5 w-6 -mt-0.5" aria-hidden="true">
        <defs>
          <linearGradient id="moduleGaugeGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#22c55e" />
            <stop offset="33%" stopColor="#eab308" />
            <stop offset="66%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#ef4444" />
          </linearGradient>
        </defs>
        <path
          d="M2 9a6 6 0 0 1 12 0"
          fill="none"
          stroke="url(#moduleGaugeGrad)"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line x1="8" y1="9" x2={nx} y2={ny} stroke="#e8dcb8" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="8" cy="9" r="1" fill="#e8dcb8" />
      </svg>
      {/* The arc alone carries the reading on a phone; spelling out "7/10" beside it is what
          tips the masthead onto a second row once a hand with a difficulty is answered. The
          number stays in the (i) popup. Mirrors the old /problems gauge, which hid this same
          text on its narrowest tier. */}
      <span className="hidden sm:inline">{level}/10</span>
    </span>
  );
}
